<script lang="ts" setup>
import ButtonSettings from '@Widgets/Classroom/ButtonSettings.vue'
import ButtonMic from '@Widgets/Classroom/ButtonMic.vue'
import ButtonCamera from '@Widgets/Classroom/ButtonCamera.vue'
import ButtonShare from '@Widgets/Classroom/ButtonShare.vue'
import ButtonPip from '@Widgets/Classroom/ButtonPip.vue'
import ButtonHowToJoin from '@Widgets/Classroom/ButtonHowToJoin.vue'
import ButtonChat from '@Widgets/Classroom/ButtonChat.vue'
import ButtonLearningPlatform from '@Widgets/Classroom/ButtonLearningPlatform.vue'

defineOptions({
  name: 'ClassroomControlsBar',
})
</script>

<template>
  <div class="classroom-controls-bar">
    <div class="classroom-controls-bar__group classroom-controls-bar__group--left">
      <ButtonSettings />
    </div>

    <div class="classroom-controls-bar__group classroom-controls-bar__group--center">
      <ButtonMic />
      <ButtonCamera />
      <ButtonShare />
      <ButtonPip />
    </div>

    <div class="classroom-controls-bar__group classroom-controls-bar__group--right">
      <ButtonLearningPlatform />
      <ButtonHowToJoin />
      <ButtonChat />
    </div>
  </div>
</template>

<style scoped lang="scss" src="@scss/components/Widgets/Classroom/ClassroomControlsBar.scss" />
